// days since epoch (unique number per day)
const MS_PER_DAY = 8.64e7;

export default (date = new Date()) => Math.floor(date / MS_PER_DAY);
